import {Select} from '@mantine/core';
import type React from 'react';
import {MdSearch} from 'react-icons/md';

type Props = {
  companyList: string[];
  value: string;
  onChange: (value: string) => void;
  /** 選択時のコールバック */
  onSubmit?: (value: string) => void;
  variant?: 'pc' | 'sp';
};

// PC版の入力フィールド幅
const PC_INPUT_WIDTH = 280;

// SP版のドロップダウンスタイル（画面幅いっぱいに表示）
const SP_DROPDOWN_STYLES = {
  left: '16px !important',
  right: 'auto !important',
  transform: 'none !important',
  width: 'calc(100vw - 32px)',
  minWidth: 'calc(100vw - 32px)',
  maxWidth: 'calc(100vw - 32px)',
} as const;

/**
 * エントリー管理の企業名検索コンポーネント
 * PC版とSP版で異なるスタイルを適用
 */
export const CompanySearch: React.FC<Props> = ({
  companyList,
  value,
  onChange,
  onSubmit,
  variant = 'pc',
}) => {
  const isPc = variant === 'pc';
  const iconSize = isPc ? '20px' : '16px';
  const size = isPc ? 'sm' : 'xs';

  const handleChange = (selectedValue: string | null) => {
    const newValue = selectedValue ?? '';
    onChange(newValue);
    onSubmit?.(newValue);
  };

  return (
    <Select
      placeholder="企業名で検索"
      icon={<MdSearch size={iconSize} />}
      data={companyList}
      value={value || null}
      onChange={handleChange}
      searchable
      clearable
      nothingFound="該当なし"
      size={size}
      dropdownPosition="bottom"
      maxDropdownHeight={320}
      className={isPc ? '' : 'flex-1'}
      styles={{
        input: {
          borderRadius: '20px',
          ...(isPc && {width: PC_INPUT_WIDTH}),
        },
        dropdown: isPc ? {} : SP_DROPDOWN_STYLES,
      }}
    />
  );
};
